module.exports = __webpack_public_path__ + "static/media/BG-01.cb2eed1d.jpg";